import React, { useEffect } from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import Hidden from "@material-ui/core/Hidden";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from "react-i18next";
// @material-ui/icons
import Menu from "@material-ui/icons/Menu";
// core components
import AdminNavbarLinks from "./AdminNavbarLinks.js";
import eightAxios from "configs/axiosConfig";
import { ButtonGroup } from "@material-ui/core";
import { STORAGE_CONSTANT, MAIN_URL } from "configs/constants";
// import Button from "components/CustomButtons/Button.js";

//hooks
import { getTabElements, useRouteName } from "hooks";

import styles from "assets/jss/material-dashboard-react/components/headerStyle.js";
import Button from "components/CustomButtons/Button.js";
import { Tab, Tabs } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import { useSidebar } from "../Sidebar/SidebarContext";

const useStyles = makeStyles(styles);

export default function Header(props) {
  const { t } = useTranslation();
  const history = useHistory();
  const submitUrl = MAIN_URL.USER;
  const userId = localStorage.getItem(STORAGE_CONSTANT.ID);
  const { activeTab, setActiveTab } = useSidebar();
  const classes = useStyles();
  // const routeName = useRouteName();
  const { color } = props;
  // const [tab, setTab] = useState(null);
  const appBarClasses = classNames({
    [" " + classes[color]]: color,
  });
  const handleTab = (event, newValue) => {
    event.preventDefault();
    setActiveTab(newValue);
  };
  const handleOnclickLanguage = (value) => {
    const payload = { language: value };
    eightAxios
      .patch(`${submitUrl}/${userId}/`, payload)
      .then((response) => {
        console.log(response.data);
      })
      .catch((error) => {
        console.log(error.message);
      });
    localStorage.setItem("locale", value);
    window.location.reload();
  };

  function getPosition(string, subString, index) {
    return string.split(subString, index).join(subString).length;
  }

  useEffect(() => {
    getTabElements(props.routes).forEach((tabUrl, index) => {
      let hasRadioInside;
      if (tabUrl.radioInsideTab) {
        const tabUrlSlice = tabUrl.url.slice(0, tabUrl.url.lastIndexOf("/"));
        const locationPathnameSlice = location.pathname.slice(
          0,
          getPosition(location.pathname, "/", 4)
        );

        if (tabUrlSlice === locationPathnameSlice) {
          hasRadioInside = true;
        }
      }

      if (
        tabUrl.url &&
        (hasRadioInside ||
          tabUrl.url === location.pathname.slice(0, tabUrl.url.length))
      ) {
        setActiveTab(index);
      }
    });
  }, [location.pathname]);
  let tabs = getTabElements(props.routes);
  return (
    <AppBar className={classes.appBar + appBarClasses}>
      <Toolbar className={classes.container}>
        <div className={classes.flex}>
          {tabs.length ? (
            <Tabs
              // className={classes.title}
              variant="scrollable"
              value={activeTab}
              indicatorColor="primary"
              textColor="primary"
              onChange={handleTab}
            >
              {tabs.map((tabUrl, index) => {
                return (
                  <Tab
                    style={{ border: "2px", borderColor: "black" }}
                    wrapped
                    key={index}
                    label={t(tabUrl.name)}
                    icon={
                      tabUrl.icon ? (
                        <FontAwesomeIcon icon={tabUrl.icon} />
                      ) : null
                    }
                    onClick={(event) => {
                      handleTab(event, index);
                      history.push(tabUrl.url);
                    }}
                  />
                );
              })}
            </Tabs>
          ) : (
            <Button color="transparent" href="" className={classes.title}>
              {t("Dashboard")}
            </Button>

      
          )}
        </div>
        <ButtonGroup size="small" aria-label="small outlined button group">
          <Button
            style={{
              maxWidth: "30px",
              maxHeight: "30px",
              minWidth: "30px",
              minHeight: "30px",
              backgroundColor: "white",
              color: localStorage.getItem("locale") === "en" ? "red" : "black",
            }}
            onClick={() => {
              handleOnclickLanguage("en");
            }}
          >
            EN
          </Button>
          <Button
            style={{
              maxWidth: "30px",
              maxHeight: "30px",
              minWidth: "30px",
              minHeight: "30px",
              backgroundColor: "white",
              color: localStorage.getItem("locale") === "my" ? "red" : "black",
            }}
            onClick={() => {
              handleOnclickLanguage("my");
            }}
          >
            BM
          </Button>
        </ButtonGroup>
        <Hidden smDown implementation="css">
          <AdminNavbarLinks />
        </Hidden>
        <Hidden mdUp implementation="css">
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={props.handleDrawerToggle}
          >
            <Menu />
          </IconButton>
        </Hidden>
      </Toolbar>
    </AppBar>
  );
}

Header.propTypes = {
  color: PropTypes.oneOf(["primary", "info", "success", "warning", "danger"]),
  handleDrawerToggle: PropTypes.func,
  routes: PropTypes.arrayOf(PropTypes.object),
};
